import Popup from "@Views/comp/Popup";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { useTranslation } from "react-i18next";
import emailPopup from '@Images/email_popup.gif';

const RejectionEmailCollectionPopup = forwardRef(({},ref)=>{

    const { t } = useTranslation();
    const msg:any = t("comMsg", { returnObjects: true });

    const rejectionEmailCollectionPopupRef:any = useRef(); 
    useImperativeHandle(ref,()=>({
        isOpen(val:boolean){
            rejectionEmailCollectionPopupRef['current'].isOpen(val);
        }
    }))

    return (
        <Popup title={msg['rejectionEmailCollectionPopupTitle']} className="modal-lg" ref={rejectionEmailCollectionPopupRef}>
            <div className="modal-body set-height">
                <div className="modal-comp">
                    <div className="txt-con">
                        <div className="emailImg-box" tabIndex={0}>
                            <img src={emailPopup} alt="이메일주소 무단 수집거부" />
                        </div>
                        <div className="btn-wrap">
                            <button type="button" className="btn btn-popup positive" onClick={() => rejectionEmailCollectionPopupRef['current'].isOpen(false)}>{msg['confirm']}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    )
})
export default RejectionEmailCollectionPopup;